import { render, staticRenderFns } from "./TSelectPaperModal.vue?vue&type=template&id=2e01f614&scoped=true"
import script from "./TSelectPaperModal.vue?vue&type=script&lang=js"
export * from "./TSelectPaperModal.vue?vue&type=script&lang=js"
import style0 from "./TSelectPaperModal.vue?vue&type=style&index=0&id=2e01f614&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e01f614",
  null
  
)

export default component.exports